module.exports = __webpack_public_path__ + "img/banner.95a1f7ce.png";